<!-- Skeleton mientras carga -->
<div class="photos-grid" *ngIf="loading">
  <div class="photo-skeleton" *ngFor="let i of [0,1,2,3,4,5]"></div>
</div>

<!-- Grid de fotos -->
<div class="photos-grid" *ngIf="!loading && pictures.length > 0">
  <div
    class="photo-item"
    [class.hide-on-mobile]="i === 3"
    *ngFor="let picture of displayPictures; let i = index"
    (click)="openLightbox(i)">
    <img [src]="picture.url" [alt]="'Foto ' + (i + 1)" loading="lazy" />

    <!-- Overlay hover normal -->
    <div class="photo-overlay"
      [class.hidden]="(i === 2 && pictures.length > 3) || (i === 3 && pictures.length > 4)">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        <line x1="11" y1="8" x2="11" y2="14"></line>
        <line x1="8" y1="11" x2="14" y2="11"></line>
      </svg>
    </div>

    <!-- Overlay "+n" mobile (3ª foto, siempre visible) -->
    <div class="photo-overlay photo-overlay--more show-on-mobile"
      *ngIf="i === 2 && pictures.length > 3">
      <span>+{{ mobileMoreCount }}</span>
    </div>

    <!-- Overlay "+n" desktop (4ª foto, siempre visible) -->
    <div class="photo-overlay photo-overlay--more hide-on-mobile"
      *ngIf="i === 3 && pictures.length > 4">
      <span>+{{ desktopMoreCount }}</span>
    </div>

    <div class="photo-owner-badge" *ngIf="picture.ownerInfo">
      {{ picture.ownerInfo.name }}
      <img *ngIf="picture.ownerInfo.verified" src="/assets/verified.png" class="badge-verified" />
    </div>
  </div>
</div>

<!-- Lightbox -->
<div class="lightbox" *ngIf="lightboxOpen" (click)="closeLightbox()">
  <div class="lightbox-inner" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="lightbox-header">
      <div class="lightbox-meta">
        <span class="lbx-counter">{{ lightboxIndex + 1 }} / {{ pictures.length }}</span>
        <div class="lbx-owner" *ngIf="lightboxPicture?.ownerInfo">
          <span>{{ lightboxPicture!.ownerInfo!.name }}</span>
          <img *ngIf="lightboxPicture!.ownerInfo!.verified" src="/assets/verified.png" class="lbx-verified" />
        </div>
      </div>
      <button class="lbx-close" (click)="closeLightbox()">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Imagen principal -->
    <div class="lbx-image-area">
      <button class="lbx-nav lbx-prev" (click)="prev()" *ngIf="pictures.length > 1">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      <img [src]="lightboxPicture?.url" class="lbx-image" />
      <button class="lbx-nav lbx-next" (click)="next()" *ngIf="pictures.length > 1">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>

    <!-- Thumbnails -->
    <div class="lbx-thumbs" *ngIf="pictures.length > 1">
      <div
        class="lbx-thumb"
        *ngFor="let p of pictures; let i = index"
        [class.active]="i === lightboxIndex"
        (click)="goTo(i)">
        <img [src]="p.url" />
      </div>
    </div>

  </div>
</div>
